import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    { name: "Dr. D.G. Desai", remarks: "In charge" },
    { name: "Dr. Poonam Verma", remarks: "Member" },
    { name: "Dr. Garima Diwan", remarks: "Member" },
    { name: "Dr. Shameem Ahmed Khan", remarks: "Member" },
    { name: "Ms. Yalika", remarks: "Member" },
    { name: "Dr. Himanshu Shekhar Kar", remarks: "Member" }
];

const StudentsGrievence = () => {
    return (
        <>
            <title>Student Grievance Redressal Committee | ISBM University</title>
            <meta
                name="description"
                content="The Student Grievance Redressal Committee at ISBM University resolves student concerns—academic, administrative & personal—with fairness, transparency & care."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Student's Grievence Redressal Committee</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Student's Grievence Redressal Committee
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Student's Grievance Redressal Committee</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University prioritizes student well-being and believes in resolving
                                concerns with fairness and transparency. The Student's Grievance Redressal
                                Committee is established to address any academic, administrative, or personal
                                issues faced by students during their time at the university. This committee
                                provides a structured platform for students to voice their grievances and ensures
                                that they are addressed promptly and effectively.
                            </p>
                            <p className="text-muted">
                                Comprising faculty members, administrative staff, and student representatives,
                                the committee follows a fair and confidential process to investigate and resolve
                                complaints. Regular feedback mechanisms and awareness programs are also organized
                                to ensure a positive and inclusive learning environment. ISBM University remains
                                committed to creating a supportive campus where every student feels heard, respected,
                                and valued.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Student's Grievence Redressal Committee</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default StudentsGrievence;
